import { createFileRoute, Outlet } from '@tanstack/react-router';

function PortalKnowledgeBase() {
  return <Outlet />;
}

export const Route = createFileRoute('/org/$orgSlug/portal/knowledge-base')({
  component: PortalKnowledgeBase,
});